var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "mds-fieldset",
        [
          _c("mds-combo-box", {
            attrs: {
              label: _vm.translate(
                "scheduler.modal.parameters.dataset.holdings.view.label"
              ),
              "data-set": _vm.viewOptions,
            },
          }),
          _vm._v(" "),
          _c("mds-combo-box", {
            attrs: {
              label: _vm.translate(
                "scheduler.modal.parameters.dataset.holdings.number.label"
              ),
              "data-set": _vm.numberOfHoldingsOptions,
            },
          }),
          _vm._v(" "),
          _c("mds-combo-box", {
            attrs: {
              label: _vm.translate(
                "scheduler.modal.parameters.dataset.holdings.frequency.label"
              ),
              "data-set": _vm.portfolioFrequencyOptions,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }